import types from "./types";
import api from "../api/quiz";
import {createError, logError, logSuccess} from "../../../ui/Notify";
import {getFullProgram, getProgram} from "../../../ManageOOP/Resources/OpMod/MyOPMod/store/actions";
import {getQuizCard, getQuizMain} from "./actions";

function getErrorMessage(errorResponse) {
  if (errorResponse.data && errorResponse.data.errors) {
    return  errorResponse.data.errors.map(({message}) => message).join(", ");
  }
  return errorResponse;
}

function updateQuizRequest() {
  return {
    type: types.UPDATE_QUIZ_MAIN_REQUEST,
    isUpdatingQuiz: true
  };
}

function updateQuizRequestComplete(updatedQuiz) {
  return {
    type: types.UPDATE_QUIZ_MAIN_COMPLETED,
    isUpdatingQuiz: false,
    updatedQuiz
  };
}

function updateQuizRequestError(updatedQuizError) {
  return {
    type: types.UPDATE_QUIZ_MAIN_ERROR,
    isUpdatingQuiz: false,
    updatedQuizError
  };
}

export function updateQuizMain(id, data) {
  return dispatch => {
    dispatch(updateQuizRequest());
    return api.updateQuizMain(id, data)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(updateQuizRequestComplete(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = getErrorMessage(err.response);
          logError(message);
          dispatch(updateQuizRequestError(message));
        } else {
          logError(err);
          dispatch(updateQuizRequestError(createError("Не удалось обновить данные опроса")));
        }
      });
  };
}

function updateQuizLogoRequest() {
  return {
    type: types.UPDATE_QUIZ_LOGO_REQUEST,
    isUpdatingLogo: true
  };
}

function updateQuizLogoCompleted(updatedLogo) {
  return {
    type: types.UPDATE_QUIZ_LOGO_COMPLETED,
    isUpdatingLogo: false,
    updatedLogo
  };
}

function updateQuizLogoError(logoUpdateError) {
  return {
    type: types.UPDATE_QUIZ_LOGO_ERROR,
    isUpdatingLogo: false,
    logoUpdateError
  };
}

export function updateQuizLogo(id, file) {
  return (dispatch) => {
    dispatch(updateQuizLogoRequest());
    return api
      .updateLogo(id, file)
      .then(response => {
        if (response.status === 200) {
          logSuccess("Успешно обновлено");
          dispatch(updateQuizLogoCompleted(response.data));
          dispatch(getQuizMain(id));
          dispatch(getQuizCard(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateQuizLogoError(message));
        } else {
          logError(err);
          dispatch(updateQuizLogoError(createError("Не удалось отправить запрос на обновление изображения")));
        }
      });
  };
}

export function deleteQuizLogo(id) {
  return (dispatch) => {
    dispatch(updateQuizLogoRequest());
    return api
      .deleteLogo(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateQuizLogoCompleted(response.data));
          dispatch(getQuizMain(id));
          dispatch(getQuizCard(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateQuizLogoError(message));
        } else {
          logError(err);
          dispatch(updateQuizLogoError(createError("Не удалось отправить запрос на удаление изображения")));
        }
      });
  };
}

export default {
  updateQuizMain,
  updateQuizLogo,
  deleteQuizLogo
};
